import { Component, OnInit, Input } from '@angular/core';
import { EmailService } from '../../../../shared/services/email.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-email-address',
  templateUrl: './select-email-address.component.html',
  styleUrls: ['./select-email-address.component.scss']
})
export class SelectEmailAddressComponent implements OnInit {

  @Input() caseId: number = -1;

  selectedAddress: any;
  selectedToAddresses: string = '';
  selectedCCAddresses: string = '';

  emailAddresses: any[] = [];

  constructor(
  private emailService: EmailService,
  public activeModal: NgbActiveModal) {
    
  }

  ngOnInit(): void {
    this.getEmailAddressesForCase();
  }

  getEmailAddressesForCase(){
    this.emailService.getEmailAddressesForCase(this.caseId).subscribe((response : any) => {
      this.emailAddresses = response.emailRecipients;
    });
  }

  selectAddress(address: any){
    this.selectedAddress = address;
  }

  addToAddress(address: any){
    if(address)
      this.selectedToAddresses += address.emailAddress + '; ';
  }

  addCCAddress(address: any){
    if(address)
      this.selectedCCAddresses += address.emailAddress + '; ';
  }

  selectAndClose()
  {
    let selectedAddress = {
      toAddresses: this.selectedToAddresses,
      ccAddresses: this.selectedCCAddresses
    };

   this.activeModal.close(selectedAddress);
  }
}
